import { styled } from '@mui/material/styles';
import { Box, Typography, TextField, Autocomplete, Button, Divider } from '@mui/material';

export const TitleTypography = styled(Typography)({
  fontSize: "1.75rem",
  fontWeight: "bold"
});

export const SubtitleTypography = styled(Typography)<{ theme: any }>(({ theme }) => ({
  fontSize: "1.25rem",
  color: theme.palette.text.secondary
}));

export const SpacedTypography = styled(Typography)({
  marginTop: "42px"
});

export const ImageUploadBox = styled(Box)<{ theme: any }>(({ theme }) => ({
  height: "135px",
  width: "240px",
  borderRadius: "12px",
  backgroundColor: theme.palette.background.default,
  cursor: "pointer"
}));

export const ImagePreview = styled('img')({
  width: "100%",
  height: "100%",
  objectFit: "cover",
  borderRadius: "12px",
  border: "1px solid gray"
});

export const ImagePlaceholderBox = styled(Box)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  height: "100%"
});

export const ErrorTypography = styled(Typography)({
  fontSize: "0.75rem"
});

export const FieldTypography = styled(Typography)({
  marginTop: "26px"
});

export const StyledTextField = styled(TextField)({
  marginTop: "16px",
  width: "100%",
  '& fieldset': {
    borderRadius: '19px'
  }
});

export const StyledAutocomplete = styled(Autocomplete<string, false, true, true>)({
  marginTop: "16px",
  '& fieldset': {
    borderRadius: '19px'
  }
});

export const DescriptionTextField = styled(TextField)({
  marginTop: "16px",
  marginBottom: "16px",
  width: "100%",
  '& fieldset': {
    borderRadius: '23px'
  }
});

interface ToggleDrawerButtonProps {
    drawerOpen?: boolean;
}

export const ToggleDrawerButton = styled(Button, {
    label: "ToggleDrawerButton",
    shouldForwardProp: (prop) => prop !== 'drawerOpen'
})<ToggleDrawerButtonProps>(({theme, drawerOpen}) => ({
    "&:hover": {
        borderColor: "#E2E3EB",
        backgroundColor: theme.palette.background.default,
    },
    backgroundColor: theme.palette.background.default,
    borderColor: theme.palette.text.secondary,
    borderRadius: "19px",
    color: theme.palette.text.secondary, // drawer z-index is 1200
    fontSize: "0.875rem",
    fontWeight: "bold",
    height: "38px",
    lineHeight: "2.0",
    padding: "6px 24px",
    position: "absolute",
    textTransform: "none",
    top: "30px",
    left: drawerOpen ? `${window.innerWidth * 0.28 + 80}px` : '80px',
    transition: "all 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms",
    zIndex: 1201
}));

export const FormContainerBox = styled(Box)(({theme}) => ({
    margin: "58px 18px 0px 74px",
    overflow: "auto",
    paddingRight: "56px",
    scrollbarWidth: "thin"
}));

export const StyledDivider = styled(Divider)(({ theme }) => ({
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(3)
}));